export default "__VITE_ASSET__DStC0irt__"